import React from 'react';
import { Link } from 'react-router-dom';

const PostCard = ({ post }) => {
  if (!post) return null;
  return (
    <Link to={`/post/detail/${post.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
      <div style={{marginBottom:20, background:'#f8f8f8', borderRadius:8, padding:12, cursor:'pointer', transition:'box-shadow 0.2s', boxShadow:'0 1px 4px #0001'}}>
        <div style={{fontWeight:'bold', fontSize:'1.05em'}}>{post.workName || '作品名なし'}</div>
        {post.displayName && (
          <div style={{color:'#1976d2', fontSize:'0.95em', margin:'2px 0 4px 0'}}>
            投稿者: {post.displayName}
          </div>
        )}
        {post.state && (
          <div style={{color:'#666', fontSize:'0.95em', margin:'4px 0 0 0'}}>
            状態: {post.state}
          </div>
        )}
        {post.workDescription && <div style={{margin:'6px 0'}}>{post.workDescription}</div>}
        {post.images && post.images.length > 0 && (
          <div style={{display:'flex', gap:8, marginTop:8}}>
            {post.images.map((img, idx) => (
              <img key={idx} src={img} alt="投稿画像" style={{width:80, height:80, objectFit:'cover', borderRadius:4, border:'1px solid #ccc'}} />
            ))}
          </div>
        )}
      </div>
    </Link>
  );
};

export default PostCard;
